import Constant from '../util/Constant';

class ApiService {
   static postData = (url, headers, requestData = {}) => {
      let proxy_url = Constant.PROXY_URL;
      return fetch(`${proxy_url}${url}`, {
         method: 'POST',
         headers: headers,
         body: requestData,
      });
   };

   static getData = (url, headers) => {
      let proxy_url = Constant.PROXY_URL;
      return fetch(`${proxy_url}${url}`, {
         method: 'GET',
         headers: headers,
      });
   };
}

export default ApiService;
